import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: 3,
		width: 15,
		height: 10,
		rx: 1,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3 6H10.5M3 8.5H7.5M10 10.5H13",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBankCheck;
